export default {
  managerNav: [
    // '/manager/dashboard' --> dashboard for event manager
    {
      eventStatus: 'drafts',
      name: 'Drafts',
      url: '/manager/events',
      icon: 'file-text-o',
      lineColor: 'line-white',
      routeTitle: 'Drafts'
    },
    {
      eventStatus: 'submitted',
      name: 'Submitted to',
      url: '/manager/events',
      icon: 'inbox',
      lineColor: 'line-blue',
      routeTitle: 'Submitted to ADURO',
      companyName: 'ADURO'
    },
    {
      eventStatus: 'review',
      name: 'Needs Review',
      url: '/manager/events',
      icon: 'eye',
      lineColor: 'line-red',
      routeTitle: 'Needs Review'
    },
    {
      eventStatus: 'approved',
      name: 'Approved',
      url: '/manager/events',
      icon: 'calendar-check-o',
      lineColor: 'line-green',
      routeTitle: 'Approved'
    },
    {
      eventStatus: 'archived',
      name: 'Archived',
      url: '/manager/events',
      icon: 'archive',
      lineColor: 'line-brown',
      routeTitle: 'Archived'
    }
  ],
  managerDashboardNav: [
    {
      text: 'Clients',
      viewName: 'ManagerDashboard',
      url: '/dashboard',
      active: false
    },
    {
      text: 'Calendar',
      viewName: 'ManagerCalendar',
      url: '/calendar',
      active: false
    },
    {
      text: 'Plan and Approve',
      viewName: 'PlanAndApprove',
      url: '/plan-and-approve',
      active: false
    },
    {
      text: 'Manage',
      viewName: 'ManageApprovedDashboard',
      url: '/manage',
      active: false
    },
    {
      text: 'Staff',
      viewName: 'StaffingSection',
      url: '/staffing',
      active: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js